import { ActivityCategory } from "@/models/ActivityCategory";

export const ActivityCategoryRequest = (argActivityCategory) => {
  let activityCategory = argActivityCategory.copy();

  if (!activityCategory.id) {
    delete activityCategory.id;
  }

  return activityCategory;
};

export const ActivityCategoryResponse = (activityCategory) => {
  return new ActivityCategory(activityCategory);
};

export const ActivityCategoriesResponse = (activityCategories) => {
  return activityCategories.map((p) => ActivityCategoryResponse(p));
};
